<div class="row">
  <div class="login-intro col-12 col-lg-7 order-2">
    <div class="login-copy">
      <div class="login-image">
        <adp-image imageKey="Signup_Create_Account_Main_Image" imageClass="main-spoe-image mx-auto d-block"></adp-image>
      </div>
    </div>
  </div>
  <div class="login col-12 col-lg-5 order-1">
    <div class="signup-section">
      <div id="sign-in-widget" [ngStyle]="{'gap': showBothOptions ? '5px' : '16px'}">
        <p *ngIf="showBothOptions" class="super-head">
          <adp-label labelKey="LookupUser_Super_Heading_Text"></adp-label>
        </p>
        <h6 [ngClass]="{'header-text': !showBothOptions, 'header-text-tmo': showBothOptions}" role="heading" aria-level="1">
          <adp-label labelKey="LookupUser_Heading_Text"></adp-label>
        </h6>
        <p>
          <adp-label labelKey="LookupUser_Option_Subheading_Text"></adp-label>
        </p>
      </div>
      <div class="registration-flow">
        <div [@.disabled]="true" *ngIf="!showBothOptions"><!-- remove animations/transitions to the tab body element -->
          <mat-tab-group *ngIf="matTabList.length" (selectedTabChange)="showOtherOption()">
            <mat-tab *ngFor="let tab of matTabList">
              <ng-template mat-tab-label>
                <adp-label [labelKey]="tab.label"></adp-label>
              </ng-template>
              <ng-container *ngTemplateOutlet="tab.template"></ng-container>
            </mat-tab>
          </mat-tab-group>
        </div>
        <div *ngIf="showBothOptions">
          <form [formGroup]="searchByOption2Fg" class="signup-form">
            <!-- Email -->
            <adp-label [labelKey]="matTabList[1]"></adp-label>
            <adp-input pgh-autofocus [resourceData]="option2SearchTerm1ResourceData" formControlName="SearchTerm1"
              class="w-100" [inputId]="'LookupUser_Field_Option2_SearchTerm1'"
              (blur)="validateOptionSearchTerm1(searchByOption2Fg, option2SearchTerm1ResourceData)" [hideValidationMessage]="false">
            </adp-input>
            <mat-error *ngIf="option2ValidationError" class="email-error">{{option2ValidationError}}</mat-error>
          </form>
          <form [formGroup]="searchByOption1Fg">
            <!-- Phone -->
            <adp-label [labelKey]="matTabList[0]"></adp-label>
            <adp-input [resourceData]="option1SearchTerm1ResourceData" formControlName="SearchTerm1"
              class="w-100" [inputId]="'LookupUser_Field_Option1_SearchTerm1'"
              (blur)="validateOptionSearchTerm1(searchByOption1Fg, option1SearchTerm1ResourceData)" [hideValidationMessage]="false">
            </adp-input>
            <mat-error *ngIf="option1ValidationError" class="email-error">{{option1ValidationError}}</mat-error>
            <mat-error *ngIf="validationError" class="email-error">{{validationError}}</mat-error>
          </form>
          <div class="form-group mb-4"
            [ngClass]="{
              'mt-4': option1ValidationError || validationError,
              'next-btn': !(option1ValidationError || validationError)
            }">
            <button mat-flat-button type="submit" color="accent" (click)="recaptchaExecute(captchaRef)"
              [tabindex]="!searchByOption1Fg.get('SearchTerm1').value && !searchByOption2Fg.get('SearchTerm1').value? '-1' : '0'">
              <adp-label labelKey="Global_Button_Next"></adp-label>
            </button>
          </div>
        </div>
        <div class="mb-3">
          <a href="javascript:void(0)" (click)="showAccountInfo()" [gtmClick]="getResourceViewLabel('LookupUser_Forgot_Account_Info_Link')">
            <adp-label labelKey="LookupUser_Forgot_Account_Info_Link"></adp-label>
          </a>
        </div>
        <hr style="margin: auto; width: 80%; height: 0.5px;">
        <div class="mt-4" style="text-align: center; display: block;">
          <adp-label labelKey="Signup_Create_Account_BackToLogin_Text"></adp-label>&nbsp;
          <a href="javascript:void(0)" (click)="goToLogin()" [gtmClick]="getResourceViewLabel('Signup_Create_Account_Login_Text')">
            <adp-label labelKey="Signup_Create_Account_Login_Text"></adp-label>
          </a>
        </div>
      </div>
      <re-captcha class="d-inline-block" size="invisible" [siteKey]="reCaptchaInvisbleKey"
        (resolved)="$event && findContractByOption($event, captchaRef)" #captchaRef="reCaptcha">
      </re-captcha>
    </div>
  </div>
</div>

<ng-template #option1TabTemplate>
  <form [formGroup]="searchByOption1Fg" class="signup-form">
    <adp-input pgh-autofocus [resourceData]="option1SearchTerm1ResourceData" formControlName="SearchTerm1"
      class="w-100" [inputId]="'LookupUser_Field_Option1_SearchTerm1'"
      (blur)="validateOptionSearchTerm1(searchByOption1Fg, option1SearchTerm1ResourceData)" [hideValidationMessage]="false">
    </adp-input>
    <mat-error *ngIf="validationError" class="email-error">{{validationError}}</mat-error>
    <div class="form-group mb-4" [ngClass]="{'mt-4': validationError, 'next-btn': !validationError}">
      <button mat-flat-button type="submit" color="accent" (click)="recaptchaExecute(captchaRef)"
        [tabindex]="!searchByOption1Fg.get('SearchTerm1').value ? '-1' : '0'">
        <adp-label labelKey="Global_Button_Next"></adp-label>
      </button>
    </div>
  </form>
</ng-template>

<ng-template #option2TabTemplate>
  <form [formGroup]="searchByOption2Fg" class="signup-form">
    <adp-input pgh-autofocus [resourceData]="option2SearchTerm1ResourceData" formControlName="SearchTerm1"
      class="w-100" [inputId]="'LookupUser_Field_Option2_SearchTerm1'"
      (blur)="validateOptionSearchTerm1(searchByOption2Fg, option2SearchTerm1ResourceData)" [hideValidationMessage]="false">
    </adp-input>
    <mat-error *ngIf="validationError" class="email-error">{{validationError}}</mat-error>
    <div class="form-group mb-4" [ngClass]="{'mt-4': validationError, 'next-btn': !validationError}">
      <button mat-flat-button type="submit" color="accent" (click)="recaptchaExecute(captchaRef)"
        [tabindex]="!searchByOption2Fg.get('SearchTerm1').value ? '-1' : '0'">
        <adp-label labelKey="Global_Button_Next"></adp-label>
      </button>
    </div>
  </form>
</ng-template>
